export const SearchAlertUserConstant = {
    USER_SEARCH_INITIATED : "USER_SEARCH_INITIATED",
    USER_SEARCH_SUCCESS : "USER_SEARCH_SUCCESS",
    USER_SEARCH_FAILED : "USER_SEARCH_FAILED", 
    USER_UPDATE_URL_STATE : "USER_UPDATE_URL_STATE", 
    USER_UPDATE_SEARCHES: "USER_UPDATE_SEARCHES", 
    USER_CHANGE_PAGE: "USER_CHANGE_PAGE"
} 